import React from 'react';
import _ from 'underscore';

import {LegacyRunQueryState, RunQueryOutputLegacyData} from 'insights/warehouse/AnalyticsWarehouseTypes';
import cellToItemIds from 'insights/warehouse/cellToItemIds';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';
import Option from 'ui-library/menus/Option';
import getAddColumnToWorklistMenu, {WorklistColumn} from 'worklists/getAddColumnToWorklistMenu';
import {apiIdHasWorklistType} from 'worklists/WorklistUtil';

interface Props {
  runQueryState: LegacyRunQueryState;
}

function runQueryOutputToWorklistItemIds(
  runQueryOutput: RunQueryOutputLegacyData,
  columnIndex: number
): Array<string> {
  // Extract worklist item ids from rows
  const allIds = runQueryOutput.rows.flatMap(
    (row) => cellToItemIds(row[columnIndex], apiIdHasWorklistType) ?? []
  );
  // Deduplicate ids
  return _.unique(allIds);
}

function runQueryOutputToWorklistColumns(runQueryOutput: RunQueryOutputLegacyData): Array<WorklistColumn> {
  return (
    runQueryOutput.headers
      .map((header, columnIndex) => ({
        name: header,
        itemIds: runQueryOutputToWorklistItemIds(runQueryOutput, columnIndex),
      }))
      // Only show columns that have worklist items
      .filter((column) => column.itemIds.length > 0)
  );
}

export default function getAddToWorklistOption(props: Props): JSX.Element {
  return (
    <Option icon="worklist-add" isDisabled={props.runQueryState.status !== AsyncStatus.SUCCESS}>
      Add to worklist
      {props.runQueryState.status === AsyncStatus.SUCCESS &&
        getAddColumnToWorklistMenu({
          columns: runQueryOutputToWorklistColumns(props.runQueryState.data),
          dropLeft: true,
        })}
    </Option>
  );
}
